import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AdminService } from '../../services/admin.service';
import { IUser } from '../../models';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mapping-popup',
  templateUrl: './mapping-popup.component.html',
  styleUrls: ['./mapping-popup.component.scss']
})
export class MappingPopupComponent implements OnInit {

  public title !: string;
  public dropdownValue !: any;
  public dropDownOptions !:any;  
  public user!:IUser;

  constructor(public bsModalRef: BsModalRef, public _adminService: AdminService,private _toastr : ToastrService,) { }

  ngOnInit(): void {
    console.log(this.user)
    if (this.title === 'Map GL Account') {
      this._adminService.getGLAccountMasterData().subscribe((res:any)=>{
        if(res.data?.length){
          this.dropDownOptions = res.data.map((item:any)=>item.code);          
        }
      });

      this._adminService.getMappedGLAccountsById(this.user.id).subscribe((res:any)=>{
        if(res.data?.gl_account_codes.length){
          console.log(res.data.gl_account_codes)
          this.dropdownValue = res.data.gl_account_codes; 
          console.log("console.log(this.dropDownOptions)",this.dropDownOptions, this.dropdownValue)        
        } else{
          this.dropdownValue = [];
        }
      })
    } else if (this.title === 'Map Cost Center') {
      this._adminService.getCostCenterMasterData().subscribe((res:any)=>{
        if(res.data?.length){
          this.dropDownOptions = res.data.map((item:any)=>item.code);
        }
      })
      this._adminService.getMappedCostCenterById(this.user.id).subscribe((res:any)=>{
        if(res.data?.cost_center_codes.length){
          this.dropdownValue = res.data.cost_center_codes;      
          console.log("console.log(this.dropDownOptions)",this.dropDownOptions, this.dropdownValue)   
        } else{
          this.dropdownValue = [];
        }
      })
    }
    console.log("console.log(this.dropDownOptions)",this.dropDownOptions)
  }

  public updateInfo() : void {
    console.log(this.dropdownValue)
    if(this.title == "Map GL Account"){
      this._adminService.mapGLAccount(this.user,this.dropdownValue).subscribe((res:any)=>{
        console.log(res);
        if(res.status === 200){
          this._toastr.success(res.message);
          this.bsModalRef.hide();
        }
      })
    } else if(this.title == "Map Cost Center"){
      this._adminService.mapCostCenter(this.user,this.dropdownValue).subscribe((res:any)=>{
        console.log(res);
        if (res.status === 200) {
          this._toastr.success(res.message);
          this.bsModalRef.hide()
        }
      })
    }
  }
}
